module.exports = __webpack_public_path__ + "static/media/pres25.6936d691.png";